module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "error-container"
  }, [_c('div', {
    staticClass: "tableHeader"
  }, [_c('p', [_vm._v("We have found error(s) in the document you have uploaded. Please look at the following message(s) and upload again.")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable"
  }, _vm._l((_vm.mistakes), function(offerMistake) {
    return _c('div', [_c('h3', [_vm._v("UPC: " + _vm._s(offerMistake.UPC))]), _vm._v(" "), _c('div', {
      staticClass: "inline-block"
    }, [(offerMistake.mistakes.error) ? _c('ul', {
      staticClass: "menu-list"
    }, _vm._l((offerMistake.mistakes.error), function(error) {
      return _c('li', {
        class: {
          "error-text": error
        }
      }, [_vm._v("\n              " + _vm._s(error) + "\n              ")])
    })) : _vm._e(), _vm._v(" "), (offerMistake.mistakes.warn) ? _c('ul', {
      staticClass: "menu-list"
    }, _vm._l((offerMistake.mistakes.warn), function(warn) {
      return _c('li', {
        class: {
          "warnings-text": warn
        }
      }, [_vm._v("\n                " + _vm._s(warn) + "\n              ")])
    })) : _vm._e()])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92959e7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload/Error.vue
// module id = 379
// module chunks = 2